import React from "react";
import styles from "./Style.module.css";
import { ButtonBase } from "@material-ui/core";
import history from "../../../libs/history.utils";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useSelector } from "react-redux";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import useIncentiveRulesCreateHook from "./IncentiveRulesCreate.hook";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const conditionsConfig = [
  // {
  //   label: "Early Bird: Subsequent Month Target Met (%)",
  //   key: "early_bird_target_met_value",
  // },
  {
    label: "Rupee value: Next Qtr 1st Month Target Met (%)",
    key: "rupee_value_next_qtr_first_month_target_met_value",
  },
  {
    label: "Rupee value: Min Product Incentive Criteria Met (%)",
    key: "rupee_value_min_product_criteria_met_value",
  },
  {
    label: "Product: Next Qtr 1st Month Target Met (%)",
    key: "product_next_qtr_first_month_target_met_value",
  },
  {
    label: "Payment Collection Realized (%)",
    key: "payment_collection_realized_value",
  },
  {
    label: "MCL Coverage Min %",
    key: "mcl_coverage_value",
  },
];

function IncentiveRulesCreate() {
  const {
    form,
    changeTextData,
    removeError,
    handleSubmit,
    errorData,
    isEdit,
    id,
  } = useIncentiveRulesCreateHook({});
  return (
    <div>
      <div>
        <ButtonBase onClick={() => history.goBack()}>
          <ArrowBackIosIcon fontSize={"small"} />{" "}
          <span className={"capitalize"}>
            <b>Manage Incentive Rules</b>
          </span>
        </ButtonBase>
        <div className={styles.newLine} />
      </div>
      <br />
      <div className={styles.plainPaper}>
        <div className={styles.newContainer}>
          <div className={styles.heading}>Incentive Details</div>
          <div className={styles.commentContainer}>
            <div className={styles.otherWrap}>
              <div className={styles.mainFlex}>
                <div className={styles.left}>
                  <div className={styles.key}>
                    <span className={styles.value}>Marketing Year:</span>
                    {form?.fy_year}
                  </div>
                </div>
                <div className={styles.right}>
                  <div className={styles.key}>
                    <span className={styles.value}>Quarter:</span>
                    {form?.quarter}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.plainPaper}>
        <div className={styles.heading}>Early Bird</div>

        <div className={styles.flexRow}>
          <div className={styles.left}>
            Early Bird: Calculation Month Target Met (%)
          </div>
          <div className={styles.right}>
            <CustomTextField
              // isError={errorData[]}
              // errorText={errorData[item?.key]}
              label={"Enter Value"}
              value={form?.early_bird_target_met_value}
              onTextChange={(text) => {
                changeTextData(text, "early_bird_target_met_value");
              }}
            />
          </div>
        </div>

        <div className={styles.flexRow}>
          <div className={styles.left}>
            Early Bird: Subsequent Month Target Met (%)
          </div>
          <div className={styles.right}>
            <CustomTextField
              // isError={errorData[]}
              // errorText={errorData[item?.key]}
              label={"Enter Value"}
              value={form?.early_bird_subsequent_target_met_value}
              onTextChange={(text) => {
                changeTextData(text, "early_bird_subsequent_target_met_value");
              }}
            />
          </div>
        </div>
      </div>

      <div className={styles.plainPaper}>
        <div className={styles.heading}>Product + Rupee Target Rules.</div>

        <div className={styles.flexRow}>
          <div className={styles.left}>
            TBM Level Target Achievement (%)
          </div>
          <div className={styles.right}>
            <CustomTextField
              // isError={errorData[]}
              // errorText={errorData[item?.key]}
              label={"Enter Value"}
              value={form?.tbm_achievement_prct}
              onTextChange={(text) => {
                changeTextData(text, "tbm_achievement_prct");
              }}
            />
          </div>
        </div>

        <div className={styles.flexRow}>
          <div className={styles.left}>
            Manager Level Target Achievement (%)
          </div>
          <div className={styles.right}>
            <CustomTextField
              // isError={errorData[]}
              // errorText={errorData[item?.key]}
              label={"Enter Value"}
              value={form?.manager_achievement_prct}
              onTextChange={(text) => {
                changeTextData(text, "manager_achievement_prct");
              }}
            />
          </div>
        </div>
        <div className={styles.flexRow}>
          <div className={styles.left}>
           Other brand achievement %age for SPI
          </div>
          <div className={styles.right}>
            <CustomTextField
              // isError={errorData[]}
              // errorText={errorData[item?.key]}
              label={"Enter Value"}
              value={form?.spi_other_achievement_prct}
              onTextChange={(text) => {
                changeTextData(text, "spi_other_achievement_prct");
              }}
            />
          </div>
        </div>
      </div>
      
      <div className={styles.plainPaper}>
        <div className={styles.heading}>Product Incentive</div>
        <div className={"formFlex"}>
          <div className={"formGroup"}>
            <CustomTextField
              // type="number"
              isError={errorData?.max_achieved_families}
              errorText={errorData?.max_achieved_families}
              label={"Max Achieved Families"}
              value={form?.max_achieved_families}
              onTextChange={(text) => {
                changeTextData(text, "max_achieved_families");
              }}
            />
          </div>
          <div className={"formGroup"}>
            <CustomTextField
              // type="number"
              isError={errorData?.min_achieved_families}
              errorText={errorData?.min_achieved_families}
              label={"Min Achieved Families"}
              value={form?.min_achieved_families}
              onTextChange={(text) => {
                changeTextData(text, "min_achieved_families");
              }}
            />
          </div>
        </div>
        <div className={"formFlex"}>
          <div className={"formGroup"}>
            <CustomTextField
              // type="number"
              isError={errorData?.spi_other_achievement_prct}
              errorText={errorData?.spi_other_achievement_prct}
              label={"Special product Incentive Achievement %"}
              value={form?.spi_other_achievement_prct}
              onTextChange={(text) => {
                changeTextData(text, "spi_other_achievement_prct");
              }}
            />
          </div>
          <div className={"formGroup"}>
             <CustomTextField
              // type="number"
              isError={errorData?.spi_payout_rate}
              errorText={errorData?.spi_payout_rate}
              label={"Special Product Incentive Rate"}
              value={form?.spi_payout_rate}
              onTextChange={(text) => {
                changeTextData(text, "spi_payout_rate");
              }}
            />
          </div>
        </div>
        <div className={styles.heading}>
          Select Category for product incentive
        </div>

        <div className={styles.tableHeader}>
          <div className={styles.left}>CATEGORY</div>
          <div className={styles.right}>RATE</div>
        </div>
        {console.log(form?.categories, "oo")}
        {form?.categories?.map((cat, idx) => (
          <div
            className={`${styles.flexRow} ${
              idx % 2 === 0 ? styles.rowEven : styles.rowOdd
            }`}
            key={idx}
          >
            <div className={styles.left}>
              {cat?.code} {cat?.name ? `(${cat?.name})` : ""}
            </div>
            <div className={styles.right}>
              <CustomTextField
             label="Enter Value"
  value={cat?.rate}
  onTextChange={(text) => {
    changeTextData(text, "rate", idx);
  }}
/>
  <div className={styles.checkboxContainer}>
  <FormControlLabel
    className={styles.checkboxLabel}
    control={
      <Checkbox
        size="small"
        color="primary"
        checked={!!cat?.is_family_incentive}
        onChange={(e) =>
          changeTextData(
            e.target.checked,
            "is_family_incentive",
            idx
          )
        }
      />
    }
    label="Eligible for family incentive"
  />

  <FormControlLabel
    className={styles.checkboxLabel}
    control={
      <Checkbox
        size="small"
        color="primary"
        checked={!!cat?.is_special_incentive}
        onChange={(e) =>
          changeTextData(
            e.target.checked,
            "is_special_incentive",
            idx
          )
        }
      />
    }
    label="Include in SPI"
  />
</div>
  </div>
          </div>
        ))}
      </div>

      <div className={styles.plainPaper}>
        <div className={styles.heading}>Overall Incentive</div>
        <div className={"formFlex"}>
          <div className={"formGroup"}>
            <CustomTextField
              // type="number"
              isError={errorData?.secondary_vs_primary_sales_ratio_min_percent}
              errorText={
                errorData?.secondary_vs_primary_sales_ratio_min_percent
              }
              label={"Secondary vs Primary Sales Ratio Min %"}
              value={form?.secondary_vs_primary_sales_ratio_min_percent}
              onTextChange={(text) => {
                changeTextData(
                  text,
                  "secondary_vs_primary_sales_ratio_min_percent"
                );
              }}
            />
          </div>
          <div className={"formGroup"}>
            <CustomTextField
              // type="number"
              isError={errorData?.incentive_cap}
              errorText={errorData?.incentive_cap}
              label={"Incentive Cap"}
              value={form?.incentive_cap}
              onTextChange={(text) => {
                changeTextData(text, "incentive_cap");
              }}
            />
          </div>
        </div>
        <div className={styles.heading}> Select General Conditions Status</div>
        <div className={styles.tableHeader}>
          <div className={styles.left}>CONDITIONS</div>
          <div className={styles.right}>VALUE</div>
        </div>
        {conditionsConfig.map((item, index) => (
          <div
            className={`${styles.flexRow} ${
              index % 2 === 0 ? styles.rowEven : styles.rowOdd
            }`}
            key={item.key}
          >
            <div className={styles.left}>{item.label}</div>
            <div className={styles.right}>
              <CustomTextField
                isError={errorData[item?.key]}
                errorText={errorData[item?.key]}
                label={"Enter Value"}
                value={form[item.key]}
                onTextChange={(text) => {
                  changeTextData(text, item?.key);
                }}
              />
            </div>
          </div>
        ))}
        <div className={`${styles.flexRow} ${styles.rowEven}`}>
          <div className={styles.left}>Call Average</div>
          <div className={styles.right21}>
            <CustomTextField
              isError={errorData?.doctor_call_avg}
              errorText={errorData?.doctor_call_avg}
              label={"Doctor Call Average"}
              value={form.doctor_call_avg}
              onTextChange={(text) => {
                changeTextData(text, "doctor_call_avg");
              }}
            />
            <CustomTextField
              isError={errorData?.doctor_meeting_avg}
              errorText={errorData?.doctor_meeting_avg}
              label={"Doctor Meeting Average"}
              value={form.doctor_meeting_avg}
              onTextChange={(text) => {
                changeTextData(text, "doctor_meeting_avg");
              }}
            />
          </div>
        </div>
        <div className={`${styles.flexRow} ${styles.rowOdd}`}>
          <div className={styles.left}>Incentive withheld amount (%)</div>
          <div className={styles.right21}>
            <CustomTextField
              isError={errorData?.sales_withheld}
              errorText={errorData?.sales_withheld}
              label={"Enter Value"}
              value={form?.sales_withheld}
              onTextChange={(text) => {
                changeTextData(text, "sales_withheld");
              }}
            />
          </div>
        </div>
      </div>
      <div className={styles.confirmedWrapper}>
        <ButtonBase onClick={handleSubmit} className={"createBtn"}>
          SAVE
        </ButtonBase>
      </div>
    </div>
  );
}

export default IncentiveRulesCreate;
